import { img, vid, pdf } from "../lib/media";
import type {
	Slide,
	VideoItem,
	HeroSlide,
	DocItem,
	TimelineItem,
	Achievement,
} from "../types";

/* ── HERO ──
   scaleFrom / scaleTo drive the Ken Burns zoom for each slide:
   scaleTo > scaleFrom zooms in, scaleTo < scaleFrom zooms out. */
export const heroSlides: HeroSlide[] = [
	// Lower-res sources: zoom and frame the subject (seated, right side).
	{ src: img("dany1_enhanced.png"), objectPosition: "70% 38%", scaleFrom: 1.1, scaleTo: 1.24 }, // zoom in
	{ src: img("danySheinbaum.jpg"), objectPosition: "center 55%", scaleFrom: 1.16, scaleTo: 1.02 }, // zoom out
	{ src: img("danyColegio.jpg"), objectPosition: "center 55%", scaleFrom: 0.96, scaleTo: 1.1 }, // zoom in
];

/* ── IMAGE CAROUSELS ── */
export const iniciosSlides: Slide[] = [
	{ src: img("danyInicios1.jpg"), label: "", objectPosition: "center 10%" },
	{ src: img("danyInicios2.jpg"), label: "", objectPosition: "10% 40%" },
	{ src: img("danyInicios3.jpg"), label: "", objectPosition: "center 40%" },
	{ src: img("danyInicios4.jpg"), label: "", objectPosition: "30% 40%" },
	{ src: img("danyInicios5.jpg"), label: "", objectPosition: "center 40%" },
];

export const activismoSlides: Slide[] = [
	{ src: img("activismo1.jpg"), label: "Marcha" },
	{ src: img("activismo2.jpg"), label: "Activismo" },
	{ src: img("activismo3.jpg"), label: "Lucha feminista" },
];

export const comiteSlides: Slide[] = [
	{ src: img("comite.jpg"), label: "Comité Feminista UAM" },
	{ src: img("comite1.jpg"), label: "Talleres" },
	{ src: img("comite2.jpg"), label: "Charlas" },
	{ src: img("comite3.jpg"), label: "Organización" },
	{ src: img("comite4.jpg"), label: "Colectiva" },
];

export const uamSlides: Slide[] = [
	{ src: img("uam1.jpg"), label: "UAM Xochimilco", objectPosition: "0% 30%" },
	{ src: img("uam3.jpg"), label: "Vida universitaria", objectPosition: "center 30%" },
	{ src: img("uam5.jpg"), label: "Campus", objectPosition: "center 30%" },
	{ src: img("optica.jpg"), label: "Trabajo académico", objectPosition: "120% 50%", scale: 1.15 },
	{ src: img("saberes_feministas.jpg"), label: "Saberes feministas", objectPosition: "40% 30%"},
];

export const conferenciasSlides: Slide[] = [
	{ src: img("conferencias1.jpg"), label: "Conferencia", objectPosition: "30% 40%" },
	{ src: img("conferencias2.jpg"), label: "Ponencia" },
	{ src: img("conferencias3.jpg"), label: "Panel", objectPosition: "-15% 50%", scale: 1.3 },
	{ src: img("conferencias4.jpg"), label: "Difusión" },
];

/* ── VIDEOS ── */
export const trayectoriaVideos: VideoItem[] = [
	{ src: vid("zocalo.mp4"), poster: vid("zocalo_thb.png"), tag: "Activismo", label: "Panel en el Zócalo", meta: "Ciudad de México", desc: "Stefanny participando en un panel de mujeres que abogan por el derecho al aborto seguro y gratuito en la plaza del Zócalo." },
	{ src: vid("tesis.mp4"), poster: vid("tesis_thb.png"), tag: "Académico", label: "Tesis de licenciatura", meta: "UAM", desc: "Investigación sobre el uso de muñecas sexuales y su impacto en las relaciones interpersonales." },
	{ src: vid("ddu2.mp4"), poster: vid("ddu2_thb.jpg"), tag: "DDU", label: "Defensoría de Derechos Universitarios", meta: "2020–2022" },
	{ src: vid("ddu1.mp4"), poster: vid("ddu1.jpg"), tag: "DDU", label: "Difusión cultural", meta: "UAM" },
	{ src: vid("federal.mp4"), poster: vid("federal_thb.jpg"), tag: "Medios", label: "Cobertura federal", meta: "Prensa" },
	{ src: vid("24horas.mp4"), poster: vid("24horas_thb.png"), tag: "Medios", label: "24 Horas", meta: "Prensa" },
];

export const moraVideos: VideoItem[] = [
	{ src: vid("Instituto Mora Primer.mp4"), poster: vid("Instituto Mora Primer_thb.png"), tag: "Instituto Mora", label: "Unidad de Género", meta: "Instituto Mora" },
	{ src: vid("Instituto Mora2.mp4"), poster: vid("Instituto Mora2_thb.png"), tag: "Instituto Mora", label: "Talleres y conferencias", meta: "Instituto Mora" },
	{ src: vid("Instituto Mora3.mp4"), poster: vid("Instituto Mora3_thb.png"), tag: "Instituto Mora", label: "Vinculación institucional", meta: "Instituto Mora" },
	{ src: vid("Instituto Mora4.mp4"), poster: vid("Instituto Mora4_thb.png"), tag: "Instituto Mora", label: "Difusión", meta: "Instituto Mora" },
	{ src: vid("MoraCuestionario.mp4"), poster: vid("MoraCuestionario_thb.png"), tag: "Instituto Mora", label: "Cuestionario", meta: "Instituto Mora" },
	{ src: vid("Instituto Mora1.mp4"), poster: vid("Instituto Mora1_thb.png"), tag: "Instituto Mora", label: "Último registro", meta: "27 sep 2023", desc: "El último video respecto al Instituto Mora, registrado el 27 de septiembre de 2023." },
];

export const justiciaVideos: VideoItem[] = [
	{ src: vid("heraldo.mp4"), poster: vid("heraldo_thb.png"), tag: "Medios", label: "Nota informativa", meta: "El Heraldo", desc: "Nota informativa acerca del fallecimiento de Stefanny y sus hijos, el 26 de septiembre de 2023." },
	{ src: vid("justicia.mp4"), poster: vid("justicia_thb.png"), tag: "Justicia", label: "Pedimos justicia", meta: "Mensaje", desc: "Mensaje para explicar la situación y pedir justicia para Stefanny y sus bebés." },
];

/* ── DOCUMENTS ── */
export const docs: DocItem[] = [
	{ href: pdf("ca-uam-ses-391_2016.pdf"), type: "Colegio Académico", title: "Sesión 391", meta: "UAM · 2016" },
	{ href: pdf("2016_uam_ca_acuerdos_sesion_394.pdf"), type: "Acuerdos", title: "Sesión 394", meta: "UAM · 2016" },
	{ href: pdf("2016_uam_ca_acuerdos_sesion_404.pdf"), type: "Acuerdos", title: "Sesión 404", meta: "UAM · 2016" },
	{ href: pdf("Acuerdo_8-15.pdf"), type: "Acuerdo", title: "Acuerdo 8-15", meta: "UAM" },
	{ href: pdf("Acuerdo_1-17.pdf"), type: "Acuerdo", title: "Acuerdo 1-17", meta: "UAM" },
	{ href: pdf("18-20.pdf"), type: "Acuerdo", title: "Acuerdo 18-20", meta: "UAM" },
	{ href: pdf("Acta_4_20.pdf"), type: "Acta", title: "Acta 4/20", meta: "UAM" },
	{ href: pdf("CIG-VE-1CIG-31-01-20.pdf"), type: "CIG-VE", title: "Sesión 31-01-20", meta: "UAM" },
	{ href: pdf("ddu1.pdf"), type: "DDU", title: "Documento DDU", meta: "Defensoría" },
];

/* ── TIMELINE ── */
export const timeline: TimelineItem[] = [
	{ year: "1992", event: "Nace Stefanny Daniela", desc: "1 de septiembre de 1992." },
	{ year: "~2007", event: "Activismo en “Cuatlicue”", desc: "Desde los 15 años participa en marchas y movimientos en defensa de los derechos estudiantiles." },
	{ year: "UNAM", event: "Letras Clásicas", desc: "Cursa varios semestres y profundiza su pasión por la literatura clásica y la poesía." },
	{ year: "UAM", event: "Psicología y Comité Feminista", desc: "Cofunda el Comité Feminista UAM Xochimilco e ingresa al Órgano Colegiado." },
	{ year: "2020–2022", event: "Defensoría de Derechos Universitarios", desc: "Ejerce como secretaria general de la DDU de la UAM." },
	{ year: "2022–2023", event: "Instituto Mora", desc: "Co-coordinadora de la Unidad de Género del Instituto de Investigaciones Dr. José María Luis Mora." },
	{ year: "2023", event: "En memoria", desc: "26 de septiembre de 2023." },
];

/* ── ACHIEVEMENTS ── */
export const achievements: Achievement[] = [
	{ n: "5", t: "Años en el Órgano Colegiado", d: "Coordinadora estudiantil desde licenciatura hasta la maestría." },
	{ n: "9", t: "Documentos de la UAM", d: "Donde figura como parte del colegiado académico." },
	{ n: "1", t: "Comité Feminista cofundado", d: "Hoy con un cubículo en su honor." },
	{ n: "ISSSTE", t: "Festival Cultural Interfaz", d: "Seleccionada por su talento en la poesía." },
];
